// TODO: move this to real.hs_code_category table.
// Consider effects of adding below data to said table in the `api/lib/invoices/sql/invoice-to-qbo.js` file
const HS_CODE_CATEGORY_MAPPINGS = {
  'Acne Treatment': {
    hsCode: '3004.20',
    category: 'Acne Treatment',
    owner: 'NRS',
    description: 'Medicaments; containing antibiotics (other than penicillins, streptomycins or their derivatives), for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Analgesic: {
    hsCode: '3004.90',
    category: 'Analgesic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Anesthetic: {
    hsCode: '3004.90',
    category: 'Anesthetic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antacid: {
    hsCode: '3004.90',
    category: 'Antacid',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Anthelmintic: {
    hsCode: '3004.90',
    category: 'Anthelmintic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Anti-Inflammatory / NSAID': {
    hsCode: '3004.90',
    category: 'Anti-Inflammatory / NSAID',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Anti-Nueropathy': {
    hsCode: '3004.50',
    category: 'Anti-Nueropathy',
    owner: 'NRS',
    description: 'Medicaments; containing vitamins or their derivatives, for therapeutic or prophylactic use, packaged for retail sale'
  },
  Antiasthmatic: {
    hsCode: '3004.90',
    category: 'Antiasthmatic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antibiotic: {
    hsCode: '3004.90',
    category: 'Antibiotic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Anticoagulant: {
    hsCode: '3004.90',
    category: 'Anticoagulant',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Anticonvulsant: {
    hsCode: '3004.50',
    category: 'Anticonvulsant',
    owner: 'NRS',
    description: 'Medicaments; containing vitamins or their derivatives, for therapeutic or prophylactic use, packaged for retail sale'
  },
  Antidiabetic: {
    hsCode: '3004.90',
    category: 'Antidiabetic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antidiarrhoeal: {
    hsCode: '3004.90',
    category: 'Antidiarrhoeal',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antiemetic: {
    hsCode: '3004.90',
    category: 'Antiemetic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antifibrinolytic: {
    hsCode: '3004.90',
    category: 'Antifibrinolytic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antifungal: {
    hsCode: '3004.90',
    category: 'Antifungal',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antigout: {
    hsCode: '3004.90',
    category: 'Antigout',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Antigout Agents': {
    hsCode: '3004.90',
    category: 'Antigout Agents',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antihelminthic: {
    hsCode: '3004.90',
    category: 'Antihelminthic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antihistamine: {
    hsCode: '3004.90',
    category: 'Antihistamine',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antihypertensive: {
    hsCode: '3004.90',
    category: 'Antihypertensive',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antiinfective: {
    hsCode: '3004.20',
    category: 'Antiinfective',
    owner: 'NRS',
    description: 'Medicaments; containing antibiotics (other than penicillins, streptomycins or their derivatives), for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antimalarial: {
    hsCode: '3004.60',
    category: 'Antimalarial',
    owner: 'NRS',
    description: 'Medicaments; containing antimalarial active principles described in Subheading Note 2 to this Chapter, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antineoplastic: {
    hsCode: '3004.90',
    category: 'Antineoplastic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antiplatelet: {
    hsCode: '3004.90',
    category: 'Antiplatelet',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antipsychotic: {
    hsCode: '3004.90',
    category: 'Antipsychotic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antiseptic: {
    hsCode: '3808.94',
    category: 'Antiseptic',
    owner: 'NRS',
    description: 'Disinfectants; other than containing goods specified in Subheading Note 1 in this Chapter; put up in forms or packings for retail sale or as preparations or articles'
  },
  Antispasmodic: {
    hsCode: '3004.49',
    category: 'Antispasmodic',
    owner: 'NRS',
    description: 'Medicaments; containing alkaloids or their derivatives; other than ephedrine, pseudoephedrine (INN) or norephedrine or their salts; for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antithyroid: {
    hsCode: '3004.39',
    category: 'Antithyroid',
    owner: 'NRS',
    description: 'Medicaments; containing hormones (but not insulin), adrenal cortex hormones or antibiotics, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Antiviral: {
    hsCode: '3004.90',
    category: 'Antiviral',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Anxiolytics: {
    hsCode: '3004.90',
    category: 'Anxiolytics',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Bronchodilator: {
    hsCode: '3004.90',
    category: 'Bronchodilator',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Cardioprotective: {
    hsCode: '3004.90',
    category: 'Cardioprotective',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Cold & Flu': {
    hsCode: '3004.90',
    category: 'Cold & Flu',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Colic Relief': {
    hsCode: '3004.90',
    category: 'Colic Relief',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Consumables: {
    hsCode: '9018.90',
    category: 'Consumables',
    owner: 'NRS',
    description: 'Medical, surgical or dental instruments and appliances; n.e.c. in heading no. 9018'
  },
  Corticosteroid: {
    hsCode: '3004.32',
    category: 'Corticosteroid',
    owner: 'NRS',
    description: 'Medicaments; containing corticosteroid hormones, their derivatives or structural analogues (but not containing antibiotics), for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Diagnostic: {
    hsCode: '3822.19',
    category: 'Diagnostic',
    owner: 'NRS',
    description: 'Reagents; diagnostic or laboratory reagents on a backing, prepared diagnostic or laboratory reagents whether or not on a backing, whether or not put up in the form of kits; n.e.c.in item 3822.1'
  },
  Diuretic: {
    hsCode: '3004.90',
    category: 'Diuretic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Ear Drop': {
    hsCode: '3004.20',
    category: 'Ear Drop',
    owner: 'NRS',
    description: 'Medicaments; containing antibiotics (other than penicillins, streptomycins or their derivatives), for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Electrolyte: {
    hsCode: '3004.90',
    category: 'Electrolyte',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Family Planning': {
    hsCode: '3004.39',
    category: 'Family Planning',
    owner: 'NRS',
    description: 'Medicaments; containing hormones (but not insulin), adrenal cortex hormones or antibiotics, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Feminine Hygiene': {
    hsCode: '9619.00',
    category: 'Feminine Hygiene',
    owner: 'NRS',
    description: 'Sanitary towels (pads) and tampons, napkins (diapers), napkin liners and similar articles, of any material'
  },
  'First Aid': {
    hsCode: '3005.90',
    category: 'First Aid',
    owner: 'NRS',
    description: 'Wadding, gauze, bandages and similar articles; (excluding adhesive dressings), impregnated or coated with pharmaceutical substances, packaged for retail sale'
  },
  Fmcg: {
    hsCode: '3306.10',
    category: 'Fmcg',
    owner: 'NRS',
    description: 'Oral or dental hygiene preparations; dentifrices'
  },
  'General Hygiene': {
    hsCode: '3808.94',
    category: 'General Hygiene',
    owner: 'NRS',
    description: 'Disinfectants; other than containing goods specified in Subheading Note 1 in this Chapter; put up in forms or packings for retail sale or as preparations or articles'
  },
  'Healthy Snack': {
    hsCode: '2106.90',
    category: 'Healthy Snack',
    owner: 'NRS',
    description: 'Food preparations; n.e.c. in item no. 2106.10'
  },
  Hemorrhoidal: {
    hsCode: '3004.32',
    category: 'Hemorrhoidal',
    owner: 'NRS',
    description: 'Medicaments; containing corticosteroid hormones, their derivatives or structural analogues (but not containing antibiotics), for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Hepatoprotective: {
    hsCode: '3004.90',
    category: 'Hepatoprotective',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Hormone Therapy': {
    hsCode: '3004.39',
    category: 'Hormone Therapy',
    owner: 'NRS',
    description: 'Medicaments; containing hormones (but not insulin), adrenal cortex hormones or antibiotics, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Immunosuppressant: {
    hsCode: '3004.90',
    category: 'Immunosuppressant',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Laxative: {
    hsCode: '3004.90',
    category: 'Laxative',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Lipase Inhibitor': {
    hsCode: '3004.90',
    category: 'Lipase Inhibitor',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Medical Device': {
    hsCode: '3004.90',
    category: 'Medical Device',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  "Men'S Health": {
    hsCode: '3004.50',
    category: "Men'S Health",
    owner: 'NRS',
    description: 'Medicaments; containing vitamins or their derivatives, for therapeutic or prophylactic use, packaged for retail sale'
  },
  'Muscle Relaxant': {
    hsCode: '3004.90',
    category: 'Muscle Relaxant',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Ophthalmic: {
    hsCode: '3004.90',
    category: 'Ophthalmic',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Oral Hygiene': {
    hsCode: '2106.90',
    category: 'Oral Hygiene',
    owner: 'NRS',
    description: 'Food preparations; n.e.c. in item no. 2106.10'
  },
  Probiotic: {
    hsCode: '2106.90',
    category: 'Probiotic',
    owner: 'NRS',
    description: 'Food preparations; n.e.c. in item no. 2106.10'
  },
  'Reproductive Health': {
    hsCode: '3004.90',
    category: 'Reproductive Health',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Sedative: {
    hsCode: '3004.90',
    category: 'Sedative',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Statin / Lipid-lowering': {
    hsCode: '3004.90',
    category: 'Statin / Lipid-lowering',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Sterile Preparation': {
    hsCode: '3004.90',
    category: 'Sterile Preparation',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Supplement: {
    hsCode: '2106.90',
    category: 'Supplement',
    owner: 'NRS',
    description: 'Food preparations; n.e.c. in item no. 2106.10'
  },
  'Sympathomimetic Agents': {
    hsCode: '3004.90',
    category: 'Sympathomimetic Agents',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Topical Preparation': {
    hsCode: '3004.90',
    category: 'Topical Preparation',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  'Ulcer Management': {
    hsCode: '3004.90',
    category: 'Ulcer Management',
    owner: 'NRS',
    description: 'Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale'
  },
  Vaccine: {
    hsCode: '3002.41',
    category: 'Vaccine',
    owner: 'NRS',
    description: 'Vaccines, toxins, cultures of micro-organisms (excluding yeasts) and similar products; for human medicine'
  }
}

module.exports = {HS_CODE_CATEGORY_MAPPINGS}
